// extracted by mini-css-extract-plugin
export default {"container":"Information_container__lIsjF","icon":"Information_icon__gZXse","info":"Information_info__wrETY"};